// Combo's props builders. It differs from the family in three of the six: the chart draws the
// answer tree, the table renders the drilled level, and the cloud takes its corpus from that
// level too. The rest -- controls, verbatims, charts model -- is the family's.

import { OE_PROPS_BUILDERS } from '@aytm/app/stats/page/question-views/oe/lib/props'

import { calcChartProps } from '@aytm/app/stats/page/question-views/cx/lib/props/chart'
import { calcTableProps } from '@aytm/app/stats/page/question-views/cx/lib/props/table'
import { calcRawData, calcWcProps } from '@aytm/app/stats/page/question-views/cx/lib/props/word-cloud'

export const CX_PROPS_BUILDERS = {
  ...OE_PROPS_BUILDERS,
  calcChartProps,
  calcTableProps,
  calcWcProps,
  calcRawData
}
